const getGroupOrder = (projectNumber) => {
  const n = (projectNumber || '').toUpperCase();
  if (n.startsWith('JS_') && !n.startsWith('JSID_')) return 0;
  if (n.startsWith('JSID_')) return 1;
  return 2;
};

export const sortProjectRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return rows || [];
  return [...rows].sort((a, b) => {
    const gA = getGroupOrder(a.project_number);
    const gB = getGroupOrder(b.project_number);
    if (gA !== gB) return gA - gB;
    if (gA === 0) return (b.project_number || '').localeCompare(a.project_number || '');
    return (a.project_number || '').localeCompare(b.project_number || '');
  });
};
